// extracted by mini-css-extract-plugin
export default {"translationContainer":"List_translationContainer__5cW7I"};